
import utils from '@/utils/utils';
import ViewBox from 'vux/src/components/view-box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'

import {HotelItem, HotelSearch, PopupCalendar, HotelFilter, BccBannerBar} from '@/components';
import PopupCondition from './components/PopupCondition';
import HotelCount from './components/HotelCount';
import {HotelSearchProxy} from "@/http/RequestProxy.class";
import {mapGetters} from 'vuex';
import SVGA from 'svgaplayerweb';

const hotelSearchProxy = new HotelSearchProxy();

export default {
components: {
BccBannerBar,
LoadMore,
ViewBox,
XHeader,
HotelItem,
HotelFilter,
HotelSearch,
PopupCalendar,
PopupCondition,
HotelCount,
},
name: 'hotel-list',
data(){
return {
isShowHotelCount: false,  // 显示酒店结果条数
isFirstLoading: true,     // 首次加载酒店列表
isShowFilter: false,
isShowNoneHotelsTips: false,
isShowHotelSearch: false,
isShowCalendar: false,
isShowCondition: false,
loadingDefaultAll: false,
loadingRecommendAll: false,
loadingAll: false,
currencyCode: 'CNY',
beginDateForArr: [],
endDateForArr: [],
searchParams: {
price_from: '',
price_to: '',
sort_by: '',
room_category: '',
options: '',
filter_options: '',
page: 1,
},
searchResult: {
total: 0,
hotel: [],
},
filterIds: '',
recommendHotel: [],

conditions: [],
};
},
computed: {
...mapGetters(['getRooms', 'getAdults', 'getAges']),

lanType(){
return +window.localStorage.getItem('lan_type');
},
},
created(){
this.concatQuery();
this.init();
},
beforeDestroy(){
utils.setBodyStyle({
height: 'auto',
});
},
mounted(){
utils.setBodyStyle({
height: '100%',
});

setTimeout(() => {
this.listenerScroll();
}, 1000);

utils.transformSVGA('#courseListSvga', '/m/static/animate-source/list-animate-bg.svga')

},
methods: {
init(){
this.getHotelData();
this.beginDateForArr = this.searchParams.date_from.split('-');
this.endDateForArr = this.searchParams.date_to.split('-');
},

concatQuery(){
const checkInParam = {
room_count: this.getRooms,
adults: this.getAdults,
children: this.getAges
};

this.searchParams = Object.assign({}, this.searchParams, this.$route.query, checkInParam);
},

/** 获取酒店列表数据 */
getHotelData(){

hotelSearchProxy.getHotelList(this.searchParams)
.then(resp => {
if(resp){
this.searchResult.total = resp.data.total;
this.searchResult.hotel.push(...resp.data.hotel);
this.concatIds();


if(resp.data.hotel.length < 20){
this.loadingDefaultAll = true;
}else{
this.loadingDefaultAll = false;
}
this.getRecommendHotel();
}

if(this.isFirstLoading){
this.isShowHotelCount = true;
}
this.isFirstLoading = false;

});
},

onSearch(){
this.$set(this.searchResult, 'hotel', []);
this.recommendHotel = [];
this.isFirstLoading = true;
this.resetPage();
this.getHotelData();
},

getRecommendHotel(){
if(this.loadingDefaultAll){
const params = Object.assign({}, this.searchParams, {filter_hotel_id: this.filterIds});

this.resetPage();

hotelSearchProxy.getRecommendRHotel(params)
.then(resp => {
if(resp){
this.recommendHotel.push(...resp.data.hotel);

if(resp.data.hotel.length < 20){
this.loadingRecommendAll = true;
}else{
this.loadingRecommendAll = false;
}
this.checkHotelData();
}


});
}else{
this.checkHotelData();
}
},

resetPage(){
this.searchParams.page = 1;
},

concatIds(){
this.filterIds = this.searchResult.hotel.map((it, idx) => {
return it.hotel_id;
}).join(',');
},

/** 检测是否有酒店搜索数据 */
checkHotelData(){
if(this.searchResult.hotel.length < 1 && this.recommendHotel.length < 1){
this.isShowNoneHotelsTips = true;
}else{
this.isShowNoneHotelsTips = false;
this.currencyCode = window.localStorage.getItem('currency_code');
}
},

/** 筛选酒店 */
onFilterHotel(params){
this.$set(this.searchResult, 'hotel', []);
this.recommendHotel = [];
this.searchParams = Object.assign({}, this.searchParams, params.filterParams, params.priceRange);
this.searchParams.page = 1;
this.conditions = utils.deepCopy(params.conditionsHash);

setTimeout(() => {
this.isFirstLoading = true;
this.getHotelData();
}, 200);
},

/** 删除筛选条件 */
onDelCondition(ev, type, key){
const filter = this.$refs.hotelFilter;

if(type == 1){

}else if(type == 2){
this.conditions.splice(key, 1);


}else{
this.searchParams.price_from = '';
this.searchParams.price_to = '';
}

this.$refs.hotelFilter.delCondition(type, key);
},

/** 获取地区或酒店 */
onGetRegion(resp){
this.searchParams.region_id = resp.region_id;
this.searchParams.hotel_id = resp.hotel_id;
this.searchParams.place_id = resp.place_id;
this.searchParams.region_name = resp.name;


if(resp.location){
this.searchParams.location = resp.location;
this.searchParams.sort_by = 4;
}else{
delete this.searchParams.location;
delete this.searchParams.sort_by;
}


if(resp.hotel_id){
const params = {
hotel_id: this.searchParams.hotel_id,
start_date: this.searchParams.date_from,
end_date: this.searchParams.date_to,
};

this.$router.push({name: 'hotel-detail', params: params});
return false;
}

const hash = {
region_id: resp.region_id,
hotel_id: resp.hotel_id,
place_id: resp.place_id,
region_name: resp.name,
};
const newQuery = Object.assign({}, this.$route.query, hash)

this.$router.replace({name: 'hotel-list', query: newQuery});
this.searchParams.page = 1;
this.searchResult.hotel = [];
setTimeout(() => {
this.isFirstLoading = true;
utils.transformSVGA('#courseListSvga', '/m/static/animate-source/list-animate-bg.svga');
this.init();
}, 200);
},

/** 隐藏酒店搜索组件 */
onHideSearch(val){
this.isShowHotelSearch = val;
},

/** 获取日期 */
onGetDate(resp){
const {start, end} = utils.combineDateFromArr(resp.start, resp.end);
const query = {...this.$route.query};

query.date_from = start;
query.date_to = end;
this.$router.replace({name: 'hotel-list', query: query});
this.concatQuery();
this.isShowCondition = false;
this.searchResult.hotel = [];
this.recommendHotel = [];
this.resetPage();
setTimeout(() => {
this.isFirstLoading = true;
this.init();
}, 200);
},

/** 后退到上一个页面 */
onClickBack(){
this.$router ? this.$router.back() : this.$router.push({name: 'hotel'});
},

/** 跳转至地图展示页面 */
onRouteToMap(){

const href = window.location.origin;
let query = '';

for(const k in this.searchParams){
const temp = `${k}=${this.searchParams[k] || ''}`;

query += `${temp}&`;
}

query = query.slice(0, query.length - 1);

let data = JSON.stringify(this.searchResult)
localStorage.setItem('hotelMarkList', data)
window.location.href = `${href}/m/hotel/list/map?${query}`;
},

/** 绑定scroll事件 */
listenerScroll(){
let that = this;
let viewBox = that.$refs.scrollViewBox.getScrollBody();


viewBox.addEventListener('scroll', function(){
if(this.clientHeight + this.scrollTop >= this.scrollHeight){
if(!that.loadingDefaultAll){
that.searchParams.page++;
that.getHotelData();
}else if(!that.loadingRecommendAll){
that.searchParams.page++;
that.getRecommendHotel();
}
}
}, false);
},

/** 渲染SVGA动画 */








},
};



// WEBPACK FOOTER //
// ./src/views/hotel-list/hotel-list.vue